module.exports = "/fonts/vendor/typeface-roboto/files/roboto-latin-500.woff2?f5b74d7ffcdf85b9dd60130fa0b2c087";